import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPaychexOnboardingSignUpContainer = () =>
    wrapRetry(
        () =>
            // TODO: This may need to be changed to a container when we create one
            import(
                /* webpackChunkName: "PaychexOnboarding" */
                '@perpay-web/fintech/components/screens/PaychexOnboarding/PaychexOnboardingSignUpContainer'
            ),
    );
